var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEaConsultancyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ea-consultancy-icon_svg__a",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ea-consultancy-icon_svg__c",
    d: "M0 0h25.276v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ea-consultancy-icon_svg__e",
    d: "M0 60h57V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ea-consultancy-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-consultancy-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24",
    fill: "#F8D7CC",
    mask: "url(#ea-consultancy-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 19.694c-2.681 0-4.5-2.193-4.5-4.899v-1.608c0-2.706 1.819-4.899 4.5-4.899s4.5 2.193 4.5 4.9v1.607c0 2.706-1.819 4.9-4.5 4.9",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 9.289c-2.028 0-3.5 1.64-3.5 3.898v1.609c0 2.259 1.472 3.899 3.5 3.899s3.5-1.64 3.5-3.9v-1.608c0-2.258-1.472-3.898-3.5-3.898m0 11.406c-3.136 0-5.5-2.537-5.5-5.9v-1.608c0-3.362 2.364-5.898 5.5-5.898S51 9.825 51 13.186v1.609c0 3.363-2.364 5.899-5.5 5.899",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 23H40c-3.503 0-5.21 3.6-5.717 4.6-.508 1-1.657 3.4-1.657 3.4L39 35.163V60h12V43h.958C54.191 43 56 41.218 56 39.02V30.2c0-4.1-2.893-7.2-6-7.2",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.724 22)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ea-consultancy-icon_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-consultancy-icon_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.234 22h-.958v-2h.958c1.677 0 3.042-1.337 3.042-2.98V8.2c0-3.709-2.586-6.2-5-6.2h-10C5.781 2 4.355 4.257 3.5 5.954l-.05.099c-.505.993-1.645 3.377-1.646 3.379L0 8.568s1.155-2.415 1.667-3.421l.047-.093C3.404 1.7 5.612 0 8.276 0h10c3.794 0 7 3.755 7 8.2v8.82c0 2.746-2.262 4.98-5.042 4.98",
    fill: "#020303",
    mask: "url(#ea-consultancy-icon_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    d: "M40 60h-2V34.523l-3.176 3.663-1.511-1.311L40 29.165z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ea-consultancy-icon_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-consultancy-icon_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#ea-consultancy-icon_svg__f)",
    d: "M50 60h2V30h-2zM44 60h2V43h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 19.694c2.681 0 5-2.193 5-4.899v-1.608c0-2.706-2.319-4.899-5-4.899s-5 2.193-5 4.9v1.607c0 2.706 2.319 4.9 5 4.9",
    fill: "#FEFEFE",
    mask: "url(#ea-consultancy-icon_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9.289c-2.168 0-4 1.784-4 3.898v1.609c0 2.114 1.832 3.899 4 3.899s4-1.785 4-3.9v-1.608c0-2.114-1.832-3.898-4-3.898m0 11.406c-3.252 0-6-2.701-6-5.9v-1.608c0-3.197 2.748-5.898 6-5.898s6 2.7 6 5.898v1.609c0 3.198-2.748 5.899-6 5.899",
    fill: "#020303",
    mask: "url(#ea-consultancy-icon_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.383 29.408C26.917 27.417 24.738 23 20 23h-8c-3.107 0-7 2.838-7 7v8c0 2.233 2.768 5 5 5v17h12V32l6.804 6.759a2.85 2.85 0 004.034.002l1.23-1.23s-4.227-6.144-5.685-8.123",
    fill: "#E74B0F",
    mask: "url(#ea-consultancy-icon_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 60h-2V29.597l8.508 8.452a1.84 1.84 0 001.313.547c.495 0 .96-.192 1.31-.542l.642-.642c-1.144-1.657-4.052-5.858-5.195-7.412a27.751 27.751 0 01-.7-1.011c-1.412-2.106-3.346-4.99-6.878-4.99h-8c-2.446 0-6 2.338-6 6v8c0 1.683 2.318 4 4 4v2c-2.804 0-6-3.195-6-6v-8c0-4.578 4.224-8 8-8h8c4.598 0 7.065 3.678 8.54 5.876.233.347.447.667.648.94 1.45 1.969 5.532 7.897 5.705 8.148l.47.686-1.818 1.819a3.824 3.824 0 01-2.723 1.128h-.003a3.82 3.82 0 01-2.723-1.131L23 34.403V60z",
    fill: "#020303",
    mask: "url(#ea-consultancy-icon_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#ea-consultancy-icon_svg__f)",
    d: "M9 60h2V30H9zM15 60h2V43h-2z"
  }))));
}
export default SvgEaConsultancyIcon;